export const DEFAULT_APP_NAME = 'Gesty';
export const DEFAULT_APP_TAGLINE = 'Gestion';
export const DEFAULT_BRAND_INITIAL = 'G';
export const DEFAULT_PRIMARY_COLOR = '#1f6fff';
export const DEFAULT_BRAND_ICON = '/brand/gesty-icon.png';
export const DEFAULT_BRAND_FAVICON = DEFAULT_BRAND_ICON;
export const DEFAULT_BRAND_LOGO = '/brand/gesty-logo.png';
export const DEFAULT_BRAND_LOGO_DARK = '/brand/gesty-logo-white.png';

export function getBrandInitial(name?: string | null): string {
  const trimmed = name?.trim();
  return (trimmed?.charAt(0) || DEFAULT_BRAND_INITIAL).toUpperCase();
}

export function isDefaultBrandName(name?: string | null): boolean {
  const trimmed = name?.trim();
  return !trimmed || trimmed.toLowerCase() === DEFAULT_APP_NAME.toLowerCase();
}
